//import { useEffect, useState } from "react";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { observer } from "mobx-react";
import {Link, useParams} from 'react-router-dom';
import Pagination from 'react-bootstrap/Pagination';
import Buscador from "./Buscador";
import CategoriasSide from "./CategoriasSide";
import CategoriasBreadcrumbs from "./CategoriasBreadcrumbs";
import Producto from "./Producto";
import productosStore from "../stores/ProductosStore";
import Loading from "./Loading";
import { NoIVA } from "./Footer";
import CarouselMarcas from "./CarouselMarcas";
import usuariosStore from "../stores/UsuariosStore";
import ScrollToTop from "../utils/ScrollToTop";

function Catalogo(props) {
    const { query, cat, catId, familia, subcat, subsubcat } = useParams();
    let { page } = useParams();
    if (!page) 
        page = 1;
    else
        page = parseInt(page);
    const { /*scroll = true,*/ simple, resXpag = 16, titulo, novedades } = props;
    let path = '';
    if (familia) {
        path = '/familias/' + familia + '/';
    } else if (novedades) {
        path = '/novedades/';
    } else if (query) {
        path = '/catalogo/buscar/' + query + '/';
    } else {
        path = '/catalogo/';
        if (cat) path += cat + '/';
        if (subcat) path += subcat + '/';
        if (subsubcat) path += subsubcat + '/';
    }

    const listar = (page, novedades, catId, familia, query) => {
        // Para que no sea un scroll infinito y tenga paginacion
        window.scrollTo(0, 0);
        let order = 'F';
        let orderD = 'DESC';
        if (novedades) {
            order = 'C';
        }
        productosStore.listarProductos(
            novedades ? undefined : catId,
            novedades ? undefined : familia,
            novedades ? undefined : query,
            page,
            //state.page + 1,
            resXpag,
            order,
            orderD,
        //    novedades ? '' : undefined
        );
    };

    const BotonCargarMas = () => {
        let items = [];
        let pages = productosStore.productos ? productosStore.productos.pages : 0;
        const pags = isMobile ? 3 : 6;
        // Vuelve 1
        if (page > 1) {
            items.push(
                <Pagination.Item key={'primero'} as={Link} to={`${path}1`}>
                    <i className="fa-solid fa-angle-double-left"></i>
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={'unomenos'} as={Link} to={`${path}${page - 1}`}>
                    <i className="fa-solid fa-angle-left"></i>
                </Pagination.Item>
            );
        }
        
        let resto = pags;
        if (page < pags + 1)
            resto += pags + 1 - page;
        for (
            let n = Math.max(1, page - pags);
            n <= Math.min(page + resto, pages);
            n++
        ) {
            items.push(
                <Pagination.Item key={n} active={n === page} as={Link} to={`${path}${n}`}> {n} </Pagination.Item>
            );
        }

        if (page < pages) {
            items.push(
                <Pagination.Item key={'unomas'} as={Link} to={`${path}${page + 1}`}>
                    <i className="fa-solid fa-angle-right"></i>
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={'ultimo'} as={Link} to={`${path}${pages}`}>
                    <i className="fa-solid fa-angle-double-right"></i>
                </Pagination.Item>
            );
        }

        return (
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 cargar-mas">
                <Pagination> {items} </Pagination>
            </div>
        )
    }

    useEffect(() => {
        listar(page, novedades, catId, familia, query);
    }, [page, novedades, catId, familia, query]);

    const loadingCSS = {
        height: '100px',
        margin: '100px',
        display: productosStore.cargando ? "block" : "none"
    };

    if (productosStore.cargando) {
        return (
            <div style={{marginTop: '140px', marginBottom: '80px'}}>
                <Loading />
            </div>
        )
    }
    if (productosStore.errorListandoNoAbort) {
        return (
            <div style={{marginTop: '140px'}}>
                <div className="row">
                    <div className="col-12 text-center mb-3 ">
                        <h3 className="bold">
                            El sitio se encuentra en mantenimiento.<br /><br />
                        </h3>
                        <h3>
                            Sepa disculpar las molestias, <br /> estaremos online a la brevedad.
                        </h3>
                    </div>
                </div>
            </div>
        )
    }

    if (simple) {
        return (
            <div>
                <div className="row d-flex justify-content-center">
                    { !productosStore.cargando && productosStore.productos && productosStore.productos.data && productosStore.productos.data.length === 0 &&
                        <span>No hay productos para mostrar.</span>
                    }
                    { productosStore.productos && productosStore.productos.data && productosStore.productos.data.map(prod =>
                        <Producto prod={prod} key={prod.id} wide />
                    )}
                </div>
                <div style={loadingCSS}> <Loading /> </div>
            </div>
        )
    }

    return (
        <div className="container-fluid px-0 mx-0" id="catalogo">
            <ScrollToTop />
            <div className="container">
                <div className="row d-flex justify-content-center">
                    {/*
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 bc-bg">
                        <CategoriasBreadcrumbs />
                    </div>
                    */}
                    <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                        <CategoriasSide novedades={false} />
                    </div>
                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 lista-productos">
                        <div className="row my-lg-4 mt-md-0 mb-md-4 mt-sm-0 mb-sm-4 mt-0 mb-4">
                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 buscador-catalogo">
                                <Buscador />
                            </div>
                        </div>

                        <div className="row listado-angosto">
                            { !productosStore.cargando && productosStore.productos && productosStore.productos.data && productosStore.productos.data.length === 0 &&
                                <span>No hay productos para mostrar.</span>
                            }
                            { productosStore.productos && productosStore.productos.data && productosStore.productos.data.map(prod =>
                                <Producto prod={prod} key={prod.id} />
                            )}
                        </div>

                        <div style={loadingCSS}> <Loading /> </div>
                        <BotonCargarMas />
                    </div>
                </div>
            </div>
            <NoIVA />
        </div>
    );
}
export default observer(Catalogo);
